import React, { useState, useEffect } from "react";
import ApiService from "../../services/ApiService";
import {
  formatDatestring,
  getDisplayDateFromStartEndDateString,
  getNumPostfix,
  randomString,
} from "../../utils";
import { toast } from "react-hot-toast";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { countries } from "../../countries";
import Footer from "../../Base/Footer";
// import bgImage from '../../assets/deal/option-header-bg.jpg'

export default function Request({ event }) {
  const [isShown, setIsShown] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [ref, inView] = useInView({
    triggerOnce: true, // This ensures the animation triggers only once when the element comes into view
  });

  const [form, setForm] = useState({
    options: [],
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    email: "",
    city: "",
    // country: "United States",
    country: "",
    businessGoals: "",
    referredBy: "",
    partners: [],
  });
  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  const partnerOnChange = (e) => {
    if (e.target.checked) {
      let arr = [...form.partners];
      arr.push(e.target.id);
      updateForm({ partners: arr });
    } else {
      updateForm({
        partners: form.partners.filter((item) => item !== e.target.id),
      });
    }
  };

  const clearForm = () => {
    setForm({
      options: [],
      firstName: "",
      lastName: "",
      company: "",
      jobTitle: "",
      email: "",
      city: "",
      // country: "United States",
      country: "",
      businessGoals: "",
      referredBy: "",
      partners: [],
    });
  };

  const submitForm = async () => {
    if (!formValid) {
      console.log(`submitForm() - form is invalid`, form);
      return;
    }
    form.eventId = event.eventId;
    form.optionRequests = form.options;
    console.log(`submitForm()`, form);
    try {
      const api = new ApiService();
      const response = await api.post(`landmark/events/submitGlobalEventRsvp`, {
        form,
      });
      console.log(`submitForm() - response`, response);
      if (response && response.success) {
        setTimeout(() => {
          // toast.success("Your response has been logged. Thank you!");
          setIsShown(true);
          setSubmitError(false);
          clearForm(); // clear inputs
        }, 50);
      } else {
        throw "Error submitting form";
      }
      // setEvents(response);
    } catch (error) {
      setIsShown(false);
      setSubmitError(true);
      console.error("Error submitting form", error);
      toast.error("An error occurred when submitting your response.");
    }
  };

  console.log(`event`, event);

  if (!event || !event.eventId) {
    return null;
  }

  let formValid = false;
  let formErrorMsg = ``;
  // validate form
  const validateForm = () => {
    const {
      options,
      firstName,
      lastName,
      company,
      jobTitle,
      email,
      city,
      country,
      businessGoals,
      referredBy,
      partners,
    } = form;
    // must select at least 1 options event
    if (!options.length) {
      formErrorMsg = "Please select at least one session";
      return false;
    }
    if (!firstName.length) {
      formErrorMsg = "Please enter your first name";
      return false;
    }
    if (!lastName.length) {
      formErrorMsg = "Please enter your last name";
      return false;
    }
    if (!company.length) {
      formErrorMsg = "Please enter your company";
      return false;
    }
    if (!jobTitle.length) {
      formErrorMsg = "Please enter your job title";
      return false;
    }
    // if (!city.length) {
    //   formErrorMsg = "Please enter your city";
    //   return false;
    // }
    // if (!country.length) {
    //   formErrorMsg = "Please select your country";
    //   return false;
    // }
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!email.length || !emailRegex.test(email)) {
      formErrorMsg = "Please enter a valid email address";
      return false;
    }
    return true;
  };
  formValid = validateForm();
  const submitDisabledClass = formValid ? "" : "disabled";

  const PartnerGrid = ({ indexMin, indexMax }) => {
    const [ref, inView] = useInView({
      triggerOnce: true, // This ensures the animation triggers only once when the element comes into view
    });
    const images = [];
    for (let i = indexMin; i <= indexMax; i++) {
      images.push(
        process.env.PUBLIC_URL + `/images/unga/sponsors/centered/${i}.png`
      );
    }
    return (
      <div className="gallery">
        {images.map((srcUrl, index) => (
          <motion.div
            className="gallery-item"
            ref={ref}
            initial={{ opacity: 0, x: 50 }} // Set your initial state
            animate={inView ? { opacity: 1, x: 0 } : {}} // Set your animation properties
            transition={{ duration: 0.7, ease: "easeOut", delay: index * 0.05 }} // Add delay based on index
            key={index} // Add key for list item
          >
            <img
              className="img-fluid"
              key={index}
              src={srcUrl}
              alt={`Sponsor`}
            />
          </motion.div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="grey-bg-section">
        <div className="options-section-title text-center">The Next 2 DEAL Episodes Have Been Announced:</div>
        <div className="options-list cap-width slightly-wider">
          {event && event.options.length
            ? event.options.map((item, index) => {
                return (
                  <RequestEventOption
                    itemData={item}
                    key={index}
                    updateForm={updateForm}
                    form={form}
                  />
                );
              })
            : null}
        </div>
      </div>
      <div className="cap-width slightly-wider">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 0 }} // Set your initial state
          animate={inView ? { opacity: 1, y: 0 } : {}} // Set your animation properties
          transition={{ duration: 1.4, ease: "easeOut" }}
        >
          <div className="form-container" id="apply">
            <div className="requestForm">
              <h3>REQUEST AN INVITATION</h3>
              {event && event.options.length
                ? event.options.map((item, index) => {
                    return (
                      <RequestEventOption
                        checkboxMode={true}
                        itemData={item}
                        key={index}
                        updateForm={updateForm}
                        form={form}
                      />
                    );
                  })
                : null}
              <h3 style={{ marginTop: "40px" }}>Your Information</h3>
              <div className="requestForm__inputs">
                <label className="input__outer sm">
                  <h5>First Name</h5>
                  <div className="input">
                    <input
                      type="name"
                      value={form.firstName}
                      onChange={onChangeInput("firstName")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Last Name</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.lastName}
                      onChange={onChangeInput("lastName")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Company</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.company}
                      onChange={onChangeInput("company")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Job title</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.jobTitle}
                      onChange={onChangeInput("jobTitle")}
                    />
                  </div>
                </label>
                {/* <label className="input__outer sm">
                  <h5>City</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.city}
                      onChange={onChangeInput("city")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Country</h5>
                  <div className="input">
                    <select
                      value={form.country}
                      onChange={onChangeInput("country")}
                    >
                      <option value="" disabled>
                        Select a country
                      </option>
                      {countries.map((country) => (
                        <option key={country} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                  </div>
                </label> */}
                <label className="input__outer sm">
                  <h5>Email</h5>
                  <div className="input">
                    <input
                      type="email"
                      value={form.email}
                      onChange={onChangeInput("email")}
                    />
                  </div>
                </label>
                <label className="input__outer sm">
                  <h5>Referred By (optional)</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.referredBy}
                      onChange={onChangeInput("referredBy")}
                    />
                  </div>
                </label>
                <label className="input__outer">
                  <h5>Tell us about your business goals (optional)</h5>
                  <div className="input">
                    <input
                      type="text"
                      value={form.businessGoals}
                      onChange={onChangeInput("businessGoals")}
                    />
                  </div>
                </label>
              </div>

              {/* <div
                className="option-header"
                style={{
                  borderRadius: "8px",
                  minHeight: "46px",
                  marginBottom: "40px",
                  marginTop: "20px",
                }}
              ></div>
              <h3 style={{ marginBottom: "7px" }}>WANT TO PARTNER?</h3>

              <h5 className="partner-text">
                Let's discuss! We welcome the opportunity to collaborate with
                partners at UNGA 2024 and beyond including our annual Flagship
                Summit. Let us know if you would be interested in any of the
                following:
              </h5> */}

              {/* <label htmlFor="partnerEventSponsorship" className="check">
                <div className="check__box">
                  <input
                    type="checkbox"
                    id="partnerEventSponsorship"
                    checked={form.partners.some(
                      (p) => p === "partnerEventSponsorship"
                    )}
                    onChange={partnerOnChange}
                  />
                  <span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icons/tick-white.svg"
                      }
                      alt="icon"
                    />
                  </span>
                </div>
                <div className="check-label">
                  I’d like to discuss an annual SIS Sponsorship
                </div>
              </label>
              <label htmlFor="partnerCustomEvent" className="check">
                <div className="check__box">
                  <input
                    type="checkbox"
                    id="partnerCustomEvent"
                    checked={form.partners.some(
                      (p) => p === "partnerCustomEvent"
                    )}
                    onChange={partnerOnChange}
                  />
                  <span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icons/tick-white.svg"
                      }
                      alt="icon"
                    />
                  </span>
                </div>
                <div className="check-label">
                  I’d like to discuss hosting a custom event at UNGA 2024 or
                  another time of year
                </div>
              </label>
              <label htmlFor="partnerIndustryTrendsBriefing" className="check">
                <div className="check__box">
                  <input
                    type="checkbox"
                    id="partnerIndustryTrendsBriefing"
                    checked={form.partners.some(
                      (p) => p === "partnerIndustryTrendsBriefing"
                    )}
                    onChange={partnerOnChange}
                  />
                  <span>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icons/tick-white.svg"
                      }
                      alt="icon"
                    />
                  </span>
                </div>
                <div className="check-label">
                  I’d like to schedule an Impact Trends Briefing with{" "}
                  <a
                    target="_blank"
                    className="purple-link"
                    href="https://www.sisomni.com/"
                  >
                    SIS Omni
                  </a>
                </div>
              </label> */}
              <div className="requestForm submit">
                {!isShown && (
                  <div className="submit-wrapper">
                    <button
                      type="submit"
                      onClick={submitForm}
                      className={`button pink-btn ${submitDisabledClass}`}
                    >
                      SUBMIT
                    </button>
                    {formErrorMsg.length ? (
                      <div className="form-invalid-msg text-center">
                        {formErrorMsg}
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
              <AnimatePresence>
                {/* {isShown && <SuccessModal setIsShown={setIsShown} />} */}
                {isShown && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <div className="submit-success-msg">
                      Thank you for your application to join our DEAL Landmark Executive Roundtable Series!
                      {/* <br></br>
                      All of our events are currently at capacity, and you have
                      been added to the waitlist.
                      <br></br>
                      If a spot opens up, the team will be in touch with a
                      confirmation including all logistic details. */}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
              <AnimatePresence>
                {submitError && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <div className="submit-success-msg">
                      There was an error when submitting your form. <br />
                      Please reach out to <b>scui@landmarkventures.com</b> and
                      he will add your application.
                      <br />
                      Sorry for the inconvenience.
                      {/* <br></br>
                      All of our events are currently at capacity, and you have
                      been added to the waitlist.
                      <br></br>
                      If a spot opens up, the team will be in touch with a
                      confirmation including all logistic details. */}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      </div>
      {/* <div className="cap-width">
        <div className="partners-section">
          <h3
            className="partners-title"
            style={{ marginBottom: "7px", textAlign: "center" }}
          >
            Thank You to our Annual Sponsors
          </h3>
          <div className="inner">
            <div className="header-img">
              <div className="header-img-text">2024 PRESENTING PARTNERS</div>
            </div>
            <PartnerGrid indexMin={1} indexMax={3} />

            <div className="header-img">
              <div className="header-img-text">2024 FEATURED PARTNERS</div>
            </div>
            <PartnerGrid indexMin={4} indexMax={12} />

            <div className="header-img">
              <div className="header-img-text">2024 SUPPORTING PARTNERS</div>
            </div>
            <PartnerGrid indexMin={13} indexMax={30} />
          </div>
        </div>
      </div> */}

      <div className="footer-section" style={{ marginTop: "70px" }}></div>
      <div className="ed-footer">
        <Footer alternate={true} />
      </div>
      {/* <div className="disclaimer">
        Landmark Events are not affiliated with CES®
      </div> */}
      {/* <div style={{ height: "400px" }}></div> */}
    </>
  );
}

const RequestEventOption = (props) => {
  const [ref, inView] = useInView({
    triggerOnce: true, // This ensures the animation triggers only once when the element comes into view
  });
  const [checked, setChecked] = useState(false);
  const onChange = (e) => {
    setChecked(e.target.checked);
    if (e.target.checked) {
      let arr = [...props.form.options];
      arr.push(props.itemData.optionId);
      props.updateForm({ options: arr });
      console.log(
        `RequestEventOption() - form options updated - option event added`,
        arr
      );
    } else {
      const adjustedArr = props.form.options.filter(
        (item) => item !== props.itemData.optionId
      );
      props.updateForm({
        options: adjustedArr,
      });
      console.log(
        `RequestEventOption() - form options updated - option event removed`,
        adjustedArr
      );
    }
  };

  let redesignMode = true;
  let checkboxMode = props.checkboxMode || false;

  const randomId = randomString(6);

  // don't show hidden options
  if (props.itemData.hidden) {
    return null;
  }

  // for the bottom form
  if (props.checkboxMode) {
    // console.log(`props.itemData.timeString`, props.itemData.timeString);
    // console.log(`props.itemData.dateString`, props.itemData.dateString);

    function removeLastSegment(inputString) {
      // Check if the input is a non-empty string
      if (typeof inputString !== "string" || inputString.trim() === "") {
        return ""; // Return an empty string for invalid input
      }

      // Split the string by whitespace
      const segments = inputString.split(/\s+/);

      // Check if there are at least two segments to remove the last one
      if (segments.length <= 1) {
        return ""; // Return an empty string if there are no segments to remove
      }

      // Remove the last element (segment) and join the remaining segments back into a string
      const result = segments.slice(0, -1).join(" ");

      return result.trim(); // Trim any extra whitespace
    }

    return (
      <label htmlFor={randomId} className="check">
        <div className="check__box">
          <input
            type="checkbox"
            id={randomId}
            checked={checked}
            onChange={onChange}
          />
          <span>
            <img
              src={process.env.PUBLIC_URL + "/images/icons/tick-white.svg"}
              alt="icon"
            />
          </span>
        </div>
<div className="check-label">
            {`${formatDatestring(props.itemData.dateString, {
              shortDay: true,
            })} | ${removeLastSegment(props.itemData.timeString.replace(" - 12:00pm", "am - 12:00pm"))}`}
            <span className="hide-mob">{` | `}</span> {/* &nbsp */}
            <div
              className="show-mob"
              style={{ width: "100%", height: "8px" }}
            ></div>
            {`${props.itemData.title}`}
          </div>
      </label>
    );
  }

  if (redesignMode) {
    let [titlePrefix, title] = props.itemData.title.split(":");
    if (!title) {
      title = titlePrefix;
      titlePrefix = null;
    }
    const shortTitle = props.itemData.shortTitle;
    const hasLogo = props.itemData.logos && props.itemData.logos.length;
    // (props.itemData.logos[0].endsWith(".png") ||
    //   props.itemData.logos[0].endsWith(".jpg") ||
    //   props.itemData.logos[0].endsWith(".jpeg"));

    // Split the description by newline character
    const paragraphs = props.itemData.description.split("\n");

    // Helper function to convert text with custom URL format to HTML with <a> tags
    const convertToLinks = (text) => {
      // Regular expression to match [URL=link]text[/URL]
      const urlPattern = /\[URL=(https?:\/\/[^\]]+)\](.*?)\[\/URL\]/gi;

      // Replace the custom format with HTML <a> tags
      const htmlText = text.replace(urlPattern, (match, url, hyperlink) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${hyperlink}</a>`;
      });

      return { __html: htmlText }; // Return as a raw HTML object
    };

    return (
      <motion.div
        ref={ref}
        initial={{ opacity: 0, x: 20, y: 0 }} // Set your initial state
        animate={inView ? { opacity: 1, y: 0, x: 0 } : {}} // Set your animation properties
        transition={{ duration: 0.9, ease: "easeOut" }}
      >
        <div className="option-container">
          <div className="option-header logo" style={{
  backgroundImage: `url(${process.env.PUBLIC_URL}/images/deal/option-header-bg.jpg)`
}}>
            {/* {props.itemData.optionId === "c369d80e" && (
              <div className="bottom">
                <div className="img-container no-mt">
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/lmv.png`}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            )} */}
            {props.itemData.optionId === "c369d80e" && (
              <div className="top mt">
                               <div className="text prefix">The French Adtech Invasion</div>

                <div className="text">
                  {`From Paris to Park Avenue: Why France’s Hottest Adtech Players Are Betting on NYC`.toUpperCase()}
                </div>
              </div>
            )}
            {props.itemData.optionId === "7d153550" && (
              <div className="top">
                {titlePrefix ? (
                  <div className="text prefix">{titlePrefix}</div>
                ) : null}

                <div className="text">{title.toUpperCase()}</div>
                {shortTitle ? (
                  <div className="text postfix">{shortTitle}</div>
                ) : null}
              </div>
            )}
            {props.itemData.optionId === "6138f837" && (
              <div className="top">
                {/* <div className="text prefix">Why Most Brands Miss the Mark</div> */}

                <div className="text prefix">The Flight to Quality in Publisher Monetization Strategies</div>

                <div className="text">
                  {`How Premium Publishers Are Rewriting the Playbook for Monetization and Value`.toUpperCase()}
                </div>

                {/* <div className="text prefix">ADTECH BREAKFAST</div>
                <div className="text">
                  SEEING THE FULL PICTURE: WHERE DATA, MEDIA, AND BRAND VISION
                  ALIGN
                </div> */}
                {/* {shortTitle ? (
                  <div className="text postfix">{shortTitle}</div>
                ) : null} */}
              </div>
            )}

            {/* {props.itemData.optionId === "7d153550" && (
              <div className="bottom">
                <div className="img-container">
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/ryff.png`}
                      className="img-fluid"
                    />
                  </div>
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/lmv.png`}
                      className="img-fluid"
                    />
                  </div>
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/verve.png`}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            )}
            {props.itemData.optionId === "6138f837" && (
              <div className="bottom">
                <div className="img-container">
                  <div className={`logo-img`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/adj/lmv.png`}
                      className="img-fluid"
                    />
                  </div>
                  <div className={`logo-img bmm`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/cannes/bmm.png`}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            )} */}
          </div>
          <div className="option-body">
            <div className="upper-container">
              <div className="date-time-container">
                <div className="date">
                  {props.itemData.dateString
                    .replace(", 2025", "")}
                </div>
                <div className="date">
                  {props.itemData.timeString
                    .replace(" - 12:00pm", "am - 12:00pm") // add the am time to clarify the start time is in the morning
                    .replace("pm PT", " PM")
                    .replace("am PT", " AM")}
                </div>
              </div>
              <div className="date-time-container text-center">
                {props.itemData.subLocation && (
                  <div className="date location">
                    {props.itemData.subLocation}
                  </div>
                )}
                {/* <div className="date location">{props.itemData.location}</div> */}
                <div className="date location">Private Zoom Roundtable</div>
              </div>
            </div>
            {/* {props.itemData.optionId === "7d153550" && (
              <div className="description">
                <p>
                  Deep discussion on how AI-driven platforms (ChatGPT, SGE, Perplexity) are reshaping content as eyeballs move from old mediums to new.
                </p>

                {/* <p>
                  <strong>Session Focus:</strong>
                </p>
                <ul>
                  <li>
                    <span className="bullet">•</span> Data driven media buying
                    and brand storytelling strategies to drive advertiser
                    outcomes
                  </li>
                  <li>
                    <span className="bullet">•</span> Strategic deal sourcing &
                    direct post-session engagement
                  </li>
                </ul> */}

                {/* <p>
                  <strong>Why This Matters:</strong>
                </p>
                <p className="no-mt">
                  With deal volume compressing and buyer selectivity increasing,
                  the need for founder preparedness and smart navigation is more
                  important than ever. This session is designed to surface
                  actionable insight and connection - providing corp dev teams
                  with direct access to high-intent, high-potential founders,
                  and giving founders a clearer sense of today’s strategic
                  landscape.
                </p> */}
              {/* </div>
                <div className="description">
                <p>
                  Join Tom Triscari and John Kunschner from Landmark Ventures
                  and Matt Drinkwater, the CEO of Bright Mountain Media, for a
                  beachfront breakfast and panel conversation.
                </p>
                <p>
                  Hosted by BMTM CEO Matt Drinkwater, the session will explore
                  how market research and proprietary data from its Big Village
                  business unifies media buying strategies to deliver more
                  effective outcomes for advertisers. This intimate conversation
                  is designed to engage senior leaders from large agencies,
                  independent shops, and forward-thinking brands seeking to
                  connect insights with impact.
                </p>
                <p>
                  In addition, for adtech companies seeking strategic
                  partnership to amplify your amazing media, creative, or data
                  tech, Bright Mountain Media is in an acquisitive state of
                  mind. Come to our breakfast, absorb our strategic context, and
                  meet Matt. Everything good starts with a conversation, and
                  there is no better place in the advertising business than
                  Cannes Lions.
                </p>
                <p>
                  <strong>Session Focus:</strong>
                </p>
                <ul>
                  <li>
                    <span className="bullet">•</span> Data driven media buying
                    and brand storytelling strategies to drive advertiser
                    outcomes
                  </li>
                  <li>
                    <span className="bullet">•</span> Strategic deal sourcing &
                    direct post-session engagement
                  </li>
                </ul>

                <p>
                  <strong>Why This Matters:</strong>
                </p>
                <p className="no-mt">
                  With deal volume compressing and buyer selectivity increasing,
                  the need for founder preparedness and smart navigation is more
                  important than ever. This session is designed to surface
                  actionable insight and connection - providing corp dev teams
                  with direct access to high-intent, high-potential founders,
                  and giving founders a clearer sense of today’s strategic
                  landscape.
                </p>
              </div> */}
           

            {props.itemData.optionId === "c369d80e" && (
              // <div className="description">
               
              //                   <p>
              //    French Adtech is having a moment. Companies like Audion, ID5, Olyzon, and VIBE are making bold moves across the Atlantic, setting up offices, hiring U.S. leadership, and forging partnerships with publishers, brands, and platforms. What’s driving the surge? Market scale, capital access, and a chance to define the next generation of privacy-first, creative, and contextual advertising infrastructure.
              //   </p>
              // </div>
              <div className="description">
  <p>
    French adtech is having a moment. Companies like Audion, ID5, Olyzon, Vibe.co,
    and xpln.ai are making bold moves across the Atlantic, setting up offices,
    hiring U.S. leadership, and forging partnerships with publishers, brands, and
    platforms.
  </p>
  <p>
    What&apos;s driving the surge? Market scale, capital access, and a chance to
    define the next generation of privacy-first, creative, and contextual
    advertising infrastructure. From Paris to Park Avenue, France&apos;s hottest
    adtech players are betting big on NYC and the broader U.S. market.
  </p>
  <p>
    This invite-only DEAL Roundtable will unpack the strategic context behind this
    &quot;French Adtech Invasion&quot; and spotlight where the most compelling
    partnership, commercial, and M&amp;A opportunities are emerging for investors,
    platforms, and operators.
  </p>

  <p>
    <strong>Key Takeaways:</strong>
  </p>
  <ul>
    <li>
      <span className="bullet">•</span> The catalysts behind this &quot;French
      Adtech Invasion&quot; and why it&apos;s accelerating now
    </li>
    <li>
      <span className="bullet">•</span> What Audion, Olyzon, Vibe.co, xpln.ai,
      and peers bring to the table and how they&apos;re navigating the U.S. market
    </li>
    <li>
      <span className="bullet">•</span> Where the most compelling partnership and
      M&amp;A opportunities lie across the ecosystem
    </li>
  </ul>

  <p>
    <strong>Featured Speakers:</strong>
  </p>
  <ul>
    <li>
      <span className="bullet">•</span> Jules Minvielle – Co-Founder &amp; CEO,
      Olyzon
    </li>
    <li>
      <span className="bullet">•</span> Arthur Larrey – Co-Founder, Audion
    </li>
    <li>
      <span className="bullet">•</span> Arthur Querou – Founder &amp; CEO,
      Vibe.co
    </li>
    <li>
      <span className="bullet">•</span> Fabien Magalon – Co-Founder &amp; CEO,
      xpln.ai
    </li>
  </ul>

  <p>
    <strong>Moderators:</strong> John Kunschner, Managing Director, Landmark
    Ventures; Tom Triscari, Sr. Advisor, Adtech, Landmark Ventures
  </p>
</div>

            )}

            {props.itemData.optionId === "6138f837"&& (
//               <div className="description">
//                 <p>
//               As performance-driven scale gives way to strategic yield and brand alignment, publishers are charting a new course -- one that favors quality over quantity. Facing privacy shifts, identity deprecation, and ad clutter fatigue, the smartest operators are doubling down on premium inventory, data integrity, and tighter advertiser relationships.
//  <br/>
// This session welcomes John Shankman, Chief Strategy Officer at Aditude, to discuss the “flight to quality” movement reshaping publisher ad strategies and the technology, partnerships, and creative approaches leading the way.
//                 </p>
//               </div>
    <div className="description">
  <p>
    As performance-driven scale gives way to strategic yield and brand alignment,
    publishers are charting a new course—one that favors quality over quantity.
    Facing privacy shifts, identity deprecation, and ad clutter fatigue, the
    smartest operators are doubling down on premium inventory, data integrity, and
    tighter advertiser relationships.
  </p>
  <p>
    This session welcomes John Shankman, Chief Strategy Officer at Aditude, for a
    candid conversation on the &quot;flight to quality&quot; reshaping publisher
    monetization strategies and the technology, partnerships, and creative
    approaches leading the way.
  </p>
  <p>
    Designed for senior leaders across publishing, adtech, and brand ecosystems,
    this invite-only DEAL Roundtable will spotlight what &quot;quality&quot;
    really means in today&apos;s market—and how to translate it into durable,
    premium performance.
  </p>

  <p>
    <strong>Key Takeaways:</strong>
  </p>
  <ul>
    <li>
      <span className="bullet">•</span> Why &quot;quality&quot; is the new
      currency in digital publishing
    </li>
    <li>
      <span className="bullet">•</span> How leading publishers are optimizing
      yield while preserving user trust and experience
    </li>
    <li>
      <span className="bullet">•</span> Tools, data strategies, and creative
      formats driving premium performance
    </li>
  </ul>

  <p>
    <strong>Featured Speaker:</strong>
  </p>
  <ul>
    <li>
      <span className="bullet">•</span> John Shankman – Chief Strategy Officer,
      Aditude
    </li>
  </ul>

  <p>
    <strong>Moderators:</strong> John Kunschner, Managing Director, Landmark
    Ventures; Tom Triscari, Sr. Advisor, Adtech, Landmark Ventures
  </p>
</div>

            )}
          </div>
        </div>
      </motion.div>
    );
  }

  if (checkboxMode) {
    return (
      <div className="req-item extended">
        <div className="req-item-content alt">
          <div className="req-item-upper">
            <div className="check__box adj">
              <input
                type="checkbox"
                id={randomId}
                checked={checked}
                onChange={onChange}
              />
              <span>
                <img
                  src={process.env.PUBLIC_URL + "/images/icons/tick-white.svg"}
                  alt="icon"
                />
              </span>
            </div>
            {/* <div className="req-item-img">
              <img className="img-fluid" src={props.itemData.imageUrl} />
            </div> */}
            <div
              onClick={() => {
                const e = { target: { checked: !checked } };
                onChange(e);
              }}
              className="req-item-header"
            >
              <h5>{props.itemData.title}</h5>
              <p className="sm short-desc">
                <span>{props.itemData.timeString.replace(" - 12:00pm", "am - 12:00pm")}</span>
                <span className="divider">{` | `}</span>
                <span>{props.itemData.location}</span>
              </p>
              <p className="sm long-desc">{props.itemData.description}</p>
            </div>
          </div>
          {/* <div className="req-item-lower">
        </div> */}
        </div>
      </div>
    );
  }
  return null;
  // return (
  //   <div className="req-item">
  //     <input type="checkbox" checked={checked} onChange={onChange} />
  //     <div className="req-item-content">
  //       <div className="req-item-upper">
  //         <div className="req-item-img">
  //           <img className="img-fluid" src={props.itemData.imageUrl} />
  //         </div>
  //         <div className="req-item-header">
  //           <h5>{props.itemData.title}</h5>
  //           <p className="sm short-desc">{props.itemData.shortDescription}</p>
  //           <p className="sm long-desc">{props.itemData.longDescription}</p>
  //         </div>
  //       </div>
  //       {/* <div className="req-item-lower">
  //       </div> */}
  //     </div>
  //   </div>
  // );
};
